import { render, staticRenderFns } from "./detail-area.vue?vue&type=template&id=17e82ec6&scoped=true"
import script from "./detail-area.vue?vue&type=script&lang=js"
export * from "./detail-area.vue?vue&type=script&lang=js"
import style0 from "./detail-area.vue?vue&type=style&index=0&id=17e82ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e82ec6",
  null
  
)

export default component.exports